module.exports = __webpack_public_path__ + "static/media/BannerLogo1_NJSpotlight.83b954fa.svg";